import * as React from 'react'

function SvgGa(props) {
	return (
		<svg viewBox="0 0 400 300" width="1em" height="1em" {...props}>
			<path fill="#3a75c4" d="M0 0h400v300H0z" />
			<path fill="#fcd116" d="M0 0h400v200H0z" />
			<path fill="#009e60" d="M0 0h400v100H0z" />
		</svg>
	)
}

export default SvgGa
